import React from "react";

const DeveloperOptions = (props) => {
    const {
        audio,
        numHumans,
        tabSwitch,
        photosAtRandom,
        detectMultipleScreens,
        forceFullScreen,
        recordSession,
        auxiliaryDevice,
    } = props.currSetting;

    const trackingList = [
        { name: "audio", label: "Noise" },
        { name: "numHumans", label: "No/Multiple Faces" },
        { name: "tabSwitch", label: "Tab Switch" },
        { name: "detectMultipleScreens", label: "External Monitors" },
        { name: "photosAtRandom", label: "Random Photos" },
        { name: "forceFullScreen", label: "Enforce Full Screen" },
        { name: "recordSession", label: "Record Session" },
        { name: "auxiliaryDevice", label: "Auxilary Device" },
    ];

    return (
        <>
            <div className="sticky top-2 z-50 developer-option bg-gray-100 rounded-xl m-5 px-5 py-3 mb-0 shadow-md">
                <h3 className="text-gray-800 font-bold mb-3">What to track</h3>
                <div className="grid grid-cols-4 fle gap-y-3 flex-row justify-between mb-3">
                    {trackingList.map((track) => (
                        <Checkbox
                            key={track.name}
                            name={track.name}
                            checked={props.currSetting[track.name]}
                            onChange={props.handleInputChange}
                            label={track.label}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const Checkbox = ({ name, checked, onChange, label }) => {
    return (
        <div className="flex col-span-1 items-center">
            <label htmlFor={name} className="relative inline-block w-11 h-6 mr-2">
                <input
                    type="checkbox"
                    name={name}
                    id={name}
                    className="opacity-0 w-0 h-0 disable-while-proctoring"
                    onChange={onChange}
                    checked={checked}
                />
                <span
                    className={`absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-400 ${
                        checked ? "bg-emerald-500" : "bg-gray-200"
                    }`}
                >
                    <span
                        className={`absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full shadow-md transition duration-400 transform ${
                            checked ? "translate-x-5" : ""
                        }`}
                    ></span>
                </span>
            </label>
            <span className={`text-sm ${checked ? "text-gray-900" : "text-gray-500"}`}>{label}</span>
        </div>
    );
};

export default DeveloperOptions;
